import React from 'react';
import { connect } from 'react-redux';
import { rawHTML } from '../common';
import { getFieldProps } from '../selectors/hybrid';

const Note = ({label, name, hide}) => {
  let classes = hide ? 'visuallyhidden' : 'note';
  
  return (
    <div className={classes} dangerouslySetInnerHTML={rawHTML(label)} />
  );
};

const mapStateToProps = (state, ownProps) => {
  const configuratorState = state.ConfiguratorStore;
  return getFieldProps(configuratorState, ownProps.field.name);
};

export default connect(mapStateToProps)(Note);